export const UNSET = 'unset'

export const CONSERVATIVE_COUNTRIES = [
  'AE', // United Arab Emirates (UAE)
  'AF', // Afghanistan
  'BD', // Bangladesh
  'BF', // Burkina Faso
  'BI', // Burundi
  'BJ', // Benin
  'BH', // Bahrain
  'BN', // Brunei
  'BT', // Bhutan
  'BY', // Belarus
  'CD', // Democratic Republic of the Congo
  'CG', // Congo (Republic of the Congo)
  'CI', // Ivory Coast (Côte d’Ivoire)
  'CM', // Cameroon
  'DZ', // Algeria
  'EG', // Egypt
  'ER', // Eritrea
  'ET', // Ethiopia
  'GH', // Ghana
  'GM', // Gambia
  'GN', // Guinea
  'GY', // Guyana
  'ID', // Indonesia
  'IQ', // Iraq
  'IR', // Iran
  'JM', // Jamaica
  'JO', // Jordan
  'KE', // Kenya
  'KG', // Kyrgyzstan
  'KI', // Kiribati
  'KM', // Comoros
  'KW', // Kuwait
  'KZ', // Kazakhstan
  'LB', // Lebanon
  'LK', // Sri Lanka
  'LR', // Liberia
  'LY', // Libya
  'MA', // Morocco
  'MG', // Madagascar
  'ML', // Mali
  'MM', // Myanmar
  'MR', // Mauritania
  'MV', // Maldives
  'MW', // Malawi
  'MY', // Malaysia
  'NE', // Niger
  'NG', // Nigeria
  'OM', // Oman
  'PG', // Papua New Guinea
  'PK', // Pakistan
  'QA', // Qatar
  'RW', // Rwanda
  'SA', // Saudi Arabia
  'SB', // Solomon Islands
  'SD', // Sudan
  'SL', // Sierra Leone
  'SN', // Senegal
  'SO', // Somalia
  'SS', // South Sudan
  'SY', // Syria
  'SZ', // Eswatini
  'TD', // Chad
  'TG', // Togo
  'TJ', // Tajikistan
  'TM', // Turkmenistan
  'TN', // Tunisia
  'TO', // Tonga
  'TT', // Trinidad and Tobago
  'TV', // Tuvalu
  'TZ', // Tanzania
  'UG', // Uganda
  'UZ', // Uzbekistan
  'VC', // Saint Vincent and the Grenadines
  'VU', // Vanuatu
  'WS', // Samoa
  'YE', // Yemen
  'ZM', // Zambia
  'ZW', // Zimbabwe
]

export const BirthAssignedSexes = [
  {value: 'female', label: 'Female'},
  {value: 'male', label: 'Male'},
  {value: 'intersex', label: 'Intersex'},
  {value: 'not-disclosed', label: "I don't want to disclose"},
  {value: UNSET, label: null},
]

export const PregnancyInfoOptions = [
  {value: 'pregnant', label: 'I’m expecting'},
  {value: 'postpartum', label: 'My partner or I recently gave birth'},
  {value: UNSET, label: null},
]

export const IsMenstrualPeriod = [
  {value: 'yes_regularly', label: 'Yes, regularly (about every 3-5 weeks)'},
  {value: 'yes_irregularly', label: 'Yes, but irregularly'},
  {value: 'no', label: 'No, not currently'},
  {value: UNSET, label: null},
]

export const LastMenstrualPeriod = [
  {value: 'less_than_12_months', label: 'Less than 12 months ago'},
  {value: 'more_than_12_months', label: 'More than 12 months ago'},
  {
    value: 'not_sure_or_medical',
    label:
      'I’m not sure / my period stopped due to an IUD, medication, or surgery',
  },
  {value: UNSET, label: null},
]

export const MenopauseSymtoms = [
  {value: 'hot_flashes', label: 'Hot Flashes'},
  {value: 'irritability', label: 'Irritability'},
  {
    value: 'heart_discomfort',
    label: 'Chest Discomfort',
  },
  {value: 'dryness_of_vagina', label: 'Vaginal Dryness'},
  {value: 'depressive_mood', label: 'Low Mood'},
  {value: 'sexual_problems', label: 'Changes in Sexual Health'},
  {value: 'physical_mental_exhaustion', label: 'Fatigue or Exhaustion'},
  {value: 'joint_muscular_discomfort', label: 'Joint or Muscle Pain'},
  {value: 'anxiety', label: 'Anxiety'},
  {value: 'bladder_problems', label: 'Bladder Problems'},
  {value: 'sleep_problems', label: 'Sleep Changes or Disturbances'},
  {value: 'none', label: 'None'},
  {value: 'other', label: 'Other'},
  {value: UNSET, label: null},
]

export type GenderIdentityType = {
  value: string
  label: string | null
  possibleCombo: string[] | null
}

export const GenderIdentities: GenderIdentityType[] = [
  {
    value: 'female',
    label: 'Female',
    possibleCombo: ['female', 'not-disclosed', 'intersex'],
  },
  {
    value: 'male',
    label: 'Male',
    possibleCombo: ['male', 'not-disclosed', 'intersex'],
  },
  {
    value: 'trans-woman',
    label: 'Trans woman',
    possibleCombo: ['male', 'intersex', 'not-disclosed'],
  },
  {
    value: 'trans-man',
    label: 'Trans man',
    possibleCombo: ['female', 'intersex', 'not-disclosed'],
  },
  {
    value: 'diverse',
    label: 'Diverse',
    possibleCombo: ['male', 'female', 'intersex', 'not-disclosed'],
  },
  {
    value: 'gender-fluid',
    label: 'Genderfluid',
    possibleCombo: ['male', 'female', 'intersex', 'not-disclosed'],
  },
  {
    value: 'non-binary',
    label: 'Non-binary',
    possibleCombo: ['male', 'female', 'intersex', 'not-disclosed'],
  },
  {
    value: 'agender',
    label: 'Agender',
    possibleCombo: ['male', 'female', 'intersex', 'not-disclosed'],
  },
  {
    value: 'intersex',
    label: 'Intersex',
    possibleCombo: ['intersex', 'not-disclosed'],
  },
  {value: UNSET, label: null, possibleCombo: null},
]

export const RelationshipDynamics = [
  {value: 'opposite-sex', label: 'With a partner of a different gender'},
  {value: 'same-sex', label: 'With a partner of the same gender'},
  {value: 'single', label: 'On my own'},
  {value: UNSET, label: null},
]

export const FamilyFormingJourneys = [
  {
    value: 'conceive',
    label: 'setup_profile_family_forming_journey_trying_to_conceive',
  },
  {
    value: 'adopt-or-foster',
    label: 'setup_profile_family_forming_journey_adoption_or_fostering',
  },
  {value: 'surrogacy', label: 'setup_profile_family_forming_journey_surrogacy'},
  {
    value: 'preserve',
    label: 'setup_profile_family_forming_journey_fertility_preservation',
  },
  {
    value: 'exploring',
    label: 'setup_profile_family_forming_journey_still_exploring',
  },
  {value: UNSET, label: null},
]

export const REIMBURSEMENT_TYPEFORM_ID = 'xxQuqawU' // https://admin.typeform.com/form/xxQuqawU/results
